import React from 'react';

import { createComponent, Image } from 'console-kit';

const AuthImageLogo = createComponent({
  displayName: 'AuthImageLogo',
  render() {
    return <Image src={`${App.globalContext.assetURL}c/img/brand/marigold-grow-logo.svg?br=marigold`} />;
  },
});

export default AuthImageLogo;
